import React from 'react';
import PropTypes from 'prop-types';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';

import { withHasBackToCartLink } from '../../enhancers';

import { BackToCartLink } from './styles';

const CART_URL = '/cart';

/**
 * CheckoutBackToCartLink
 * @description Renders link to the cart page
 * @param {boolean} [hasBackToCartLink]
 */
function CheckoutBackToCartLink({ hasBackToCartLink }) {
    return hasBackToCartLink ? (
        <BackToCartLink real to={CART_URL}>
            <Translator tk="CHECKOUT_BACK_TO_CART_TEXT" />
        </BackToCartLink>
    ) : null;
}

CheckoutBackToCartLink.propTypes = {
    hasBackToCartLink: PropTypes.bool.isRequired,
};

/**
 * CheckoutBackToCartLink
 * @description Renders link to the cart page
 * only when current order doesn't come from PartnerPOS
 */
const EnhancedCheckoutBackToCartLink = withHasBackToCartLink(CheckoutBackToCartLink);

export { EnhancedCheckoutBackToCartLink as CheckoutBackToCartLink };
